var React = require('react');

function ConfettiImg6 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.1586 2.06104C13.1397 0.830893 6.41042 5.89399 2.37263 11.3075","stroke":"#FF553C","strokeWidth":"3.60285"}));
}

ConfettiImg6.defaultProps = {"width":"23","height":"13","viewBox":"0 0 23 13","fill":"none"};

module.exports = ConfettiImg6;

ConfettiImg6.default = ConfettiImg6;
